import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

// Uid of the organization the PMS modules (Customization, Integrations)
// operate on when the user belongs to several; null means "auto" (the first
// one). See resolveActiveOrganization.
export const PMSActiveOrganizationStore = GenericFieldFactory(
    "PMS_ACTIVE_ORGANIZATION",
);
